const listeners = new Set();

export function showToast(message, type = 'success') {
    const toast = { id: Date.now() + Math.random(), message, type };
    listeners.forEach(fn => fn(toast));
}

export function _subscribe(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
}
